<div class="filter-wrapper">
  <div class="ag-text-filter-title">{{'app.general.filter' | translate}}</div>

  <mat-form-field class="select-search">
    <input matInput type="text" [placeholder]="'app.general.search' | translate" [value]="value()" (input)="setSearch($event)" />
    <span matSuffix>
      @if(!value()) {
        <img width="24" height="24" ngSrc="../../../../assets/icons/search-filter.svg" [alt]="'app.imgAlt.search' | translate" />
      } @else {
        <button class="close-button" type="button" (click)="value.set('')">
          <img width="24" height="24" ngSrc="../../../../assets/icons/icon-close.svg" [alt]="'app.imgAlt.close' | translate" />
        </button>
      }
    </span>
  </mat-form-field>

  <div class="filter-actions">
    <app-general-button
      [buttonStyle]="'primary'"
      [buttonHeight]="32"
      [buttonName]="'app.general.approval'"
      (buttonClicked)="applyFilter()"
    />
    <app-general-button
      [buttonStyle]="'secondary'"
      [buttonHeight]="32"
      [buttonName]="'app.general.cancel'"
      (buttonClicked)="resetFilter()"
    />
  </div>
</div>
